<template>
  <div>
    <section
      v-if="cart.length > 0"
      id="cart__cart-section">
      <div class="cart__header">
        <div class="cart__header--cart-title">Your Cart</div>
        <div class="cart__header--price-column">Price</div>
        <div class="cart__header--cart-quantity">Quantity</div>
        <div class="cart__header--cart-total">Total</div>
      </div>

      <no-ssr>
        <cart-product/>
      </no-ssr>

      <div class="cart__coupon-container">
        <input
          id="coupon_code"
          v-model="couponCode"
          type="text"
          name="coupon_code"
          class="input-text"
          value
          placeholder="Enter Promo Code"
          @keyup.enter="checkCoupon"
        >
        <button
          type="submit"
          class="button more-info-button"
          name="apply_coupon"
          value="Apply"
          @click="checkCoupon"
        >Apply</button>
      </div>

      <div class="cart__totals">
        <div class="cart__totals--row">
          <div class="cart__totals--title">Subtotal</div>

          <div class="cart__totals--value">${{ cartSubTotal.toFixed(2) }}</div>
        </div>

        <div
          v-if="attachedCoupons.length >= 1"
          class="cart__totals--row">
          <div class="cart__totals--title">Coupon ({{ attachedCoupons[0].coupon_code }})</div>

          <div
            class="cart__totals--value"
          >-${{ attachedCoupons[0].discount_percent > 0 ? (cartSubTotal * (attachedCoupons[0].discount_percent / 100)).toFixed(2) : (attachedCoupons[0].base_discount_amount * -1).toFixed(2) }}</div>
        </div>
        <div class="cart__totals--row is-flex-wrap">
          <div class="cart__totals--title">
            <strong>Total*</strong>
          </div>

          <div class="cart__totals--value">
            <strong>${{ cartTotal.toFixed(2) }}</strong>
          </div>
          <small class="has-space-top">*Tax will be calculated during checkout.</small>
        </div>

        <div class="cart__cta">
          <nuxt-link
            to="/checkout"
            class="checkout-button button">Checkout</nuxt-link>
        </div>
      </div>
    </section>

    <no-ssr v-else>
      <cart-empty/>
    </no-ssr>

    <no-ssr>
      <notifications
        :duration="3000"
        classes="coupon-valid-notification"
        group="couponInvalid"
        position="top left"
      />
    </no-ssr>

    <no-ssr>
      <notifications
        :duration="3000"
        classes="coupon-valid-notification"
        group="couponValid"
        position="top left"
      />
    </no-ssr>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CartProduct from '~/components/cart/CartProduct'
import CartEmpty from '~/components/cart/CartEmpty'
export default {
  name: 'Cart',
  components: {
    CartProduct,
    CartEmpty
  },
  data: () => ({
    couponCode: '',
    couponLookupEnabled: true
  }),
  computed: {
    ...mapGetters('cart', {
      cart: 'cart',
      taxCost: 'taxCost',
      cartSubTotal: 'cartSubTotal',
      cartTotal: 'cartTotal'
    }),
    ...mapGetters('coupons', {
      attachedCoupons: 'attachedCoupons',
      invalidCoupons: 'invalidCoupons'
    })
  },
  methods: {
    async addCouponToState () {
      return this.$store.dispatch('coupons/checkCoupon', this.couponCode)
    },
    checkCoupon () {
      if (this.couponCode === '') {
        this.$notify({
          group: 'couponInvalid',
          title: 'Invalid Coupon',
          text: 'This is an invalid coupon code.',
          type: 'error'
        })
        return
      }
      if (this.couponLookupEnabled) {
        // Check the count of the coupons
        if (this.attachedCoupons.length === 1) {
          this.$notify({
            group: 'couponInvalid',
            title: 'Duplicate Coupon',
            text: 'You already have a coupon attached matching this code.',
            type: 'error'
          })

          this.couponLookupEnabled = false
        } else if (this.invalidCoupons >= 5) {
          this.$notify({
            group: 'couponInvalid',
            title: 'Maximumn Coupon Attemps',
            text: 'You have reached the maximum number of coupon attempts.',
            type: 'error'
          })
          this.couponLookupEnabled = false
        } else {
          // Check to see if coupon is in either list before making an ajax call
          const matchingAttachedCoupons = find(this.attachedCoupons, { 'coupon_code': this.couponCode })

          const matchingInvalidCoupons = find(this.invalidCoupons, { 'coupon_code': this.couponCode })

          if (matchingAttachedCoupons === undefined && matchingInvalidCoupons === undefined) {
            this.addCouponToState().then((response) => {
              if (this.attachedCoupons.length > 0) {
                this.$notify({
                  group: 'couponValid',
                  title: 'Coupon Applied',
                  text: `We will take $${this.attachedCoupons[0].base_discount_amount * -1} off your order.`,
                  type: 'success'
                })
              } else {
                this.$notify({
                  group: 'couponInvalid',
                  title: 'Invalid Coupon',
                  text: 'This is an invalid coupon code.',
                  type: 'error'
                })
              }
            })
          } else if (matchingAttachedCoupons !== undefined) {
            this.$notify({
              group: 'couponInvalid',
              title: 'Coupon Already Attached',
              text: 'You already have a coupon code attached.',
              type: 'error'
            })
          } else if (matchingInvalidCoupons !== undefined) {
            this.$notify({
              group: 'couponInvalid',
              title: 'Invalid Coupon',
              text: 'This is an invalid coupon code.',
              type: 'error'
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout-button,
.continue-shopping-button {
  margin-bottom: 15px;
  display: block;
  width: 100%;
}

#cart__cart-section {
  padding: 45px 5.5%;
  font-weight: 400;
  font-size: 0.8em;

  .empty-cart-container {
    text-align: center;
  }

  h4 {
    font-size: 1.25em;
  }

  @media screen and (max-width: 700px) {
    padding: 30px 25px 45px 25px;
  }

  .quantity-counter {
    margin: 0 auto;
    text-align: center;

    @media screen and (max-width: 620px) {
      margin: 0;
      text-align: left;
    }
  }

  .cart__quantity-counter-button {
    width: 25px;
    height: 25px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer */
    -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
    -webkit-user-select: none; /* Chrome, Safari, and Opera */
    -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
    vertical-align: middle;

    @media screen and (max-width: 850px) {
      padding: 4px;
    }
  }

  h4 {
    margin: 0;
    font-weight: 400;

    .cart__heading-break {
      display: none;

      @media screen and (max-width: 900px) {
        display: block;
      }
    }

    .cart__mobile-price-display {
      display: none;

      @media screen and (max-width: 900px) {
        display: inline;
      }
    }

    @media screen and (max-width: 500px) {
      font-size: 1em;
    }
  }
}

.cart {
  @include e("header") {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    border-bottom: 1px solid #ccc;
    padding-bottom: 20px;

    @include m("cart-title") {
      width: 57%;
      font-size: 28px;
    }

    @include m("price-column") {
      width: 18%;
      font-size: 21px;
      text-align: center;

      @media screen and (max-width: 1125px) {
        width: 15%;
      }

      @media screen and (max-width: 960px) {
        display: none;
      }
    }

    @include m("cart-quantity") {
      width: 10%;
      font-size: 21px;
      text-align: left;

      @media screen and (max-width: 1125px) {
        width: 13%;
      }

      @media screen and (max-width: 960px) {
        width: 25%;
        text-align: center;
      }

      @media screen and (max-width: 620px) {
        display: none;
      }
    }

    @include m("cart-total") {
      width: 15%;
      font-size: 21px;
      text-align: right;

      @media screen and (max-width: 620px) {
        display: none;
      }
    }
  }

  @include e("coupon-container") {
    text-align: right;
    padding: 20px 0;

    input {
      margin: 0 15px 0 0;
      font-size: 16px;
    }

    @media screen and (max-width: 620px) {
      input {
        width: 100%;
        margin: 0 auto;
        display: block;
      }

      button {
        margin: 15px 0 0 auto;
      }
    }
  }

  @include e("totals") {
    width: 30%;
    margin: 0 0 0 auto;
    padding: 30px 0;

    @include m("row") {
      display: flex;
      flex-direction: row;
      margin-bottom: 15px;

      &.is-flex-wrap {
        flex-wrap: wrap;
      }
    }

    @include m("title") {
      width: 50%;
      text-align: right;
      font-size: 21px;
      line-height: 1em;
    }

    @include m("value") {
      width: 50%;
      text-align: right;
      font-size: 21px;
      line-height: 1em;
    }

    @media screen and (max-width: 780px) {
      width: 50%;
      padding: 20px 0px;
    }

    @media screen and (max-width: 620px) {
      width: 100%;
      margin: 0 auto;
      text-align: center;
    }
  }

  @include e("cta") {
    max-width: 220px;
    margin: 45px 0px 0px auto;

    @media screen and (max-width: 620px) {
      margin: 45px auto 0px;
      max-width: 100%;
    }
  }
}
.has-space-top {
  margin-top: 5px;
  text-align: right;
  width: 100%;
}
</style>
